import { motion } from "framer-motion";
import { Mail, Phone, MapPin } from "lucide-react";

export default function ContactCTA() {
  return (
    <section className="relative py-16 bg-black sm:py-20">
      {/* Dotted background */}
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_1px_1px,rgba(255,255,255,0.12)_1px,transparent_1px)] [background-size:16px_16px]" />

      {/* Decorative arcs */}
      <div className="absolute -top-24 -left-24 w-72 h-72 rounded-full border-8 pointer-events-none border-emerald-600/40" />
      <div className="absolute bottom-10 -right-20 w-64 h-64 rounded-full border-8 pointer-events-none border-emerald-600/30" />

      <div className="relative px-6 mx-auto max-w-6xl">
        <div className="text-center">
          <motion.h2
            initial={{ opacity: 0, y: 16 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5 }}
            className="text-3xl font-extrabold leading-tight text-white sm:text-4xl lg:text-5xl"
          >
            Ready to Start Your
            <br className="hidden sm:block" />
            <span className="text-emerald-400">Insurance Career?</span>
          </motion.h2>

          <motion.p
            initial={{ opacity: 0, y: 16 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: 0.1, duration: 0.5 }}
            className="mx-auto mt-4 max-w-2xl text-sm text-gray-300 md:text-base"
          >
            Join our network of successful insurance agents and start earning competitive commissions 
            while helping people protect what matters most.
          </motion.p>

          {/* Contact Info */}
          <motion.div
            initial={{ opacity: 0, y: 16 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: 0.2, duration: 0.5 }}
            className="grid grid-cols-1 gap-4 mt-8 sm:grid-cols-3"
          >
            {[
              {
                icon: Mail,
                title: "Email Us",
                info: "agents@tripsecure.com",
                href: "mailto:agents@tripsecure.com"
              },
              {
                icon: Phone,
                title: "Call Us",
                info: "+233 55 548 8305",
                href: "tel:+233555488305"
              },
              {
                icon: MapPin,
                title: "Visit Us",
                info: "Accra, Ghana",
                href: "#"
              }
            ].map((contact, index) => (
              <motion.a
                key={contact.title}
                href={contact.href}
                initial={{ opacity: 0, y: 16 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: 0.3 + index * 0.1, duration: 0.5 }}
                className="flex flex-col items-center p-4 rounded-xl border backdrop-blur transition-all duration-300 group border-white/10 bg-white/5 hover:bg-white/10"
              >
                <div className="flex justify-center items-center w-12 h-12 text-emerald-400 rounded-full transition-colors bg-emerald-600/20 group-hover:bg-emerald-600/30">
                  <contact.icon size={24} />
                </div>
                <h3 className="mt-3 text-sm font-semibold text-white">{contact.title}</h3>
                <p className="mt-1 text-xs text-gray-400 transition-colors group-hover:text-emerald-400">
                  {contact.info}
                </p>
              </motion.a>
            ))}
          </motion.div>

          {/* CTA Button */}
          <motion.div
            initial={{ opacity: 0, y: 16 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: 0.4, duration: 0.5 }}
            className="mt-10"
          >
            <a
              href="/signup"
              className="inline-flex items-center px-8 py-4 text-lg font-semibold text-black bg-emerald-600 rounded-full shadow-lg transition-all duration-300 hover:bg-emerald-500 hover:scale-105"
            >
              Become an Agent Today
            </a>
          </motion.div>
        </div>
      </div>
    </section>
  );
}
